<template>
    <div class="portlet-body">
       <!-- ------------------------------------radio button----------------------------------------->
        <div class="form-group">
            <span class="font-red-sunglo bold">Ajouter un service ?</span>
            <input type="radio" id="servicenon"  value="servicenon" v-model="activityservicesup" >
            <label for="servicenon">Non</label>
            <input type="radio" id="serviceoui" value="serviceoui" v-model="activityservicesup">
            <label for="serviceoui">Oui</label>
        </div>
        <!-- -------------------------------------End radio button----------------------------------------->

        <!-- -------------------------------------Select activity service ----------------------------------------->
        <div class="row" v-if="activityservicesup == 'serviceoui'">
            <div class="col-md-3">
                <label>Choisissez le nom du service</label>
                <select v-model="officeActivityServiceSelected" class="form-control">
                    <!--<option disabled value="">Choisissez</option>-->
                    <option v-for="service in activityServices" :value="service.id">{{ service.name }}</option>
                </select>
            </div>
            <div class="col-md-3">
                <label>Prix du service (HT en €)</label>
                <input type="text" ref="input" class="form-control"  v-model="selectedService.price" />
            </div>
        </div>

        <input type="hidden" name="activityservice_id" :value="selectedService.id">
        <input type="hidden" name="activityserviceprice" :value="selectedService.price">
        <input type="hidden" name="tauxtva" :value="selectedService.tva">
       <!--- -------------------------------------- end add activity service------------------------------------->

        <div id="errors_valid" v-show="errors != false" style="color:red">
            Veuillez sélectionner un professionnel ou vérifier que vous avez ajouté une activité dans la rubrique activité plus haut.
        </div>
    </div>
</template>

<script>
    export default {
        name: 'addServiceBilling',
        props: ['officeActivityServices', 'activityServiceSelected'],
        data () {
            return {
                'activityServices': Object.assign([], this.officeActivityServices),
                'officeActivityServiceSelected': this.activityServiceSelected.id,
                'activityservicesup': 'servicenon',
                'errors' : false
            }
        },
        computed: {
            selectedService: function () {
                if(this.activityservicesup=='servicenon'){
                    return Object.assign([],{"id":null,"price":null,"tva":null});
                }
                return Object.assign([],this.activityServices.find(element => element.id == this.officeActivityServiceSelected));
            }
        },
        mounted () {
            if(this.officeActivityServiceSelected){
                this.activityservicesup = 'serviceoui'
            }
        }
    }
</script>